<style>
.atd-theme > div {
    width: 53px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none;*/
    -webkit-appearance: none;
    margin: 0;
}
div.vue-swatches__container:not(.vue-swatches--inline){
    z-index:999;
}

</style>

<style scoped>
a.el-button.el-button--info.pull-right:hover,.el-button--info:focus,.el-button--info:active {
    border-color:#fff;
    background-color:#fff;
    color:#333;
}
.content-wrapper .content {
    padding-top: 95px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.el-select {
    display: block;
}

.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-input-group__prepend {
    cursor: pointer;
}

button[disabled=disabled],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
    border-color: rgba(200, 200, 200, 2.3);
}

.m-t-15 {
    margin-top: 15px;
}


</style>
<template>
<!-- <transition name="el-zoom-in-top"> -->
<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title">{{(domId)?'Edit':'Create'}} Domain</h3>
            </div>
            <div class="box-body" v-loading=isLoading>
                <form method="post" v-on:submit.prevent="onSubmit" class="form">
                    <h5>Select Publisher</h5>
                    <p v-if="!domId">Choose publisher from the dropdown or create one by clicking +add publisher</p>
                    <div class="row">
                        <div class="col-md-9">
                            <el-select v-model="pubId" placeholder="Select" filterable @change="setPubUid()">
                                <el-option v-for="pub in publishers" :data-id="pub.uuid" :key="pub.name" :label="pub.name" :value="pub.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-md-3 m-t-7" v-if="!domId">
                            <router-link to="/admin/bidders/create-publisher/" class="el-button--info m-t-15">
                                <i class="el-icon-plus el-icon-left"></i>
                                Create Publisher
                            </router-link>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-9">
                            <h5>Domain URL
                                <div v-if="!domId" style="float:right;">
                                    <div class="el-input el-input-group el-input-group--prepend">
                                        <el-checkbox v-model="addToCoreDomain" >Add to Yeti Domains</el-checkbox>
                                    </div>
                                </div>                                
                            </h5>
                            <div class="el-input el-input-group el-input-group--prepend">
                                <!-- <div tabindex="0" class="el-input-group__prepend">https://</div> -->
                                <el-input class="" v-validate="'required'" data-vv-delay="200" :class="{'input': true, 'is-danger': errors.has('name') }" name="name" type="text" placeholder="Domain URL" v-model="name"></el-input>
                            </div>
                            <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
                        </div>
                        <!-- <div v-if="!domId" class="col-md-3 m-t-10">
                            <div class="el-input el-input-group el-input-group--prepend">
                                <el-checkbox v-model="addToCoreDomain" >Add to Yeti Domains</el-checkbox>
                            </div>
                        </div> -->

                    </div>

                    <hr>
                    <h5>RTC Currency</h5>
                    <div class="row">
                        <div class="col-md-9">
                            <el-select v-model="rtcCurrency" filterable placeholder="Select RTC Currency">
                                <!-- <el-option key="" label="Select a DFP" value=""></el-option> -->
                                <el-option v-for="item in currenciesOptions" :key="item.id" :label="item.code" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <hr/>
                    <!-- <div class="row"> -->
                      <div class="demand-switch flex-col"> 
                                <div class="flex-l-m">   
                                <div style="margin-right:15px">Demand Switch:</div>

                                </div>
                                 <div class="flex-col-demandswitch">
                                     <div class="flex-sa-m" style="width:65%">
                        <strong style="margin-right:15px"> Web:</strong>
                        <div class="flex-col-c">
                        <div>Bing</div>
                        <el-input-number v-model="bing_web"  @change="handleWebBing" @input="handleWebBing" :min="0" :max="100" size="mini" style="width:120px"></el-input-number>
                        </div>

                        <el-slider
                    style="width:20%;"
                        v-model="web_traffic"
                        @change="handleWebGoogle"
                        :show-tooltip="false"
                    >
                        </el-slider>
                        <div class="flex-col-c">
                        <div>Google</div>
                        <el-input-number v-model="web_traffic"  @change="handleWebGoogle" @input="handleWebGoogle" :min="0" :max="100" size="mini" style="width:120px"></el-input-number>
                        </div>
                        </div>


                     <div class="flex-sa-m" style="width:65%; margin-top:5%">
                    <strong> Mobile:</strong>
                    <div class="flex-col-c">
                    <div>Bing</div>
                    <el-input-number v-model="bing_mobile"  @change="handleMobileBing" @input="handleMobileBing" :min="0" :max="100" size="mini" style="width:120px"></el-input-number>
                    </div>

                    <el-slider
                style="width:20%"
                    v-model="mobile_traffic"
                    @change="handleWebGoogle"
                    :show-tooltip="false"
                >
                    </el-slider>
                    <div class="flex-col-c">
                    <div>Google</div>
                    <el-input-number v-model="mobile_traffic"  @change="handleMobileGoogle" @input="handleMobileGoogle" :min="0" :max="100" size="mini" style="width:120px"></el-input-number>
                    </div>
                    </div>

                </div>
                                
                            </div>

                    <hr/>

                    <hr/>
                    <h5>Keyword config</h5>
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-md-9">
                            <el-select v-model="kwConfigVal" placeholder="Keyword config">
                                <el-option
                                v-for="item in KeywordOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>      
                        </div>                  
                    </div>                    
                    <hr/>
                    <div >
                        <div class="row">
                            <div class="col-md-2">
                                <h5>Theme Settings
                                    <el-tooltip class="item" effect="dark" content="Reset theme" placement="bottom">
                                        <!-- Button type is button to prevent this from submitting the form -->
                                        <button type="button" class=" el-button el-button--secondary el-button--mini" @click="theme={}" style="marginLeft: 5px; borderRadius: 50%; padding: 3px;">
                                            <i class="el-icon-plus el-icon-refresh"></i>
                                        </button>
                                    </el-tooltip>
                                </h5>
                            </div>                            
                        </div>
                        <theme :themeData="theme" @themeChange="updateThemeObj"/>
                    </div>
                    <hr/>

                    <div class="clearfix">
                        <button v-if="!domId" type="submit" class="el-button el-button--success" :disabled="!formValid">
                            <i class="el-icon-plus el-icon-left"></i>
                            Create Domain
                        </button>
                        <button v-else type="submit" class="el-button el-button--success" :disabled="!formValid">
                            Update Domain
                        </button>
                        <router-link to="/admin/bidders/" class="el-button el-button--danger">
                            Cancel
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import axios from 'axios';
import {
    EventBus
} from '../../../event-bus.js';
import theme from './Theme.vue';
export default {
    components:{theme},
    data: () => {
        return {
            bing_web:0,
            bing_mobile:100,
            web_traffic:100,
            mobile_traffic:0,
            domId: undefined,
            name: undefined,
            publishers: [],
            isSecure: true,
            rtcCurrency:undefined,
            pubId: undefined,
            pubUid: undefined,
            currenciesOptions: [],
            theme:{},
            isLoading:true,
            addToCoreDomain: false,            
            KeywordOptions: [{
                value: null,
                label: 'None'
            }, {
                value: 'replace_l2',
                label: 'Replace (Dominant L2)'
            }, {
                value: 'augment_similarity',
                label: 'Augment (Similarity)'
            }, {
                value: 'augment_l2',
                label: 'Augment (Dominant L2)'
            }],
            kwConfigVal: null,
        }
    },
    created: function () {
        console.log("Bidder Domain ID: ", this.$route.params.domId);
        this.domId = this.$route.params.domId
        axios.all([
                axios.get(BASE_URL + 'bidder/v1/publishers/?limit=1000'),
                axios.get(BASE_URL + 'v1/currencies/')
            ])
            .then(axios.spread((response, currency) => {
                //console.log("response",response);
                this.publishers = response.data.results;
                this.currenciesOptions = currency.data;
                if (this.$route.query.publisher) {
                    for (let i = 0; i < this.publishers.length; i++) {
                        //console.log(this.publishers[i].id);
                        if (this.publishers[i].id == parseInt(this.$route.query.publisher)) {
                            this.pubId = parseInt(this.$route.query.publisher);
                            // this.setPubUid();
                        }
                    }
                }
                if(this.domId){
                    this.initializeDomain()
                }
                this.isLoading=false
            }));

    },
    methods: {
        initializeDomain(){
            if(this.domId){
                axios.get(
                    BASE_URL +
                    `bidder/v1/domains/` +
                    this.domId +
                    "/"
                ).then(response=>{
                    var domData = response.data
                    this.pubId=domData.publisher
                    this.name=domData.url
                    this.web_traffic = domData.web_rc_switch&&100-(Number(domData.web_rc_switch)*100)
                    this.mobile_traffic = domData.mobile_rc_switch&&(Number(domData.mobile_rc_switch)*100)                   
                    this.kwConfigVal = domData.kw_enhancement;

                    if(domData.currency){
                        this.rtcCurrency = this.currenciesOptions.filter(k=>{return k.code==domData.currency.code})[0].id
                    }
                    let theme = (domData.theme)? domData.theme:this.theme;
                    this.theme = theme;
                }).catch(error=>{
                    console.log('error',error)
                })
            
            }
        },
        updateThemeObj(e){
            console.log(e)
            this.theme = e
        },
        setPubUid() {
            let i = 0;
            for (; i < this.publishers.length; i++)
                if (this.publishers[i].id == this.pubId) {
                    this.pubUid = this.publishers[i].uuid;
                    //console.log(this.pubUid);
                    break;
                }
        },
        onSubmit() {
            var domainObj = {
                    url: this.name,
                    publisher: this.pubId,
                    currency: this.rtcCurrency,
                    theme: this.theme,
                    web_rc_switch:this.web_traffic==100?0:parseFloat(100-this.web_traffic) / 100.0,
                    mobile_rc_switch: this.mobile_traffic==0?0:parseFloat(this.mobile_traffic) / 100.0,
                    theme: this.theme,         
                    kw_enhancement: this.kwConfigVal    
                }
            if(this.domId){
                // return false
                axios.put(BASE_URL+'bidder/v1/domains/'+this.domId+'/',domainObj)
                .then(response=>{
                    this.$notify({
                        title: 'Success',
                        message: 'Successfully updated domain',
                        type: 'success'
                    });
                    EventBus.$emit('update_logs', {});

                    setTimeout(() => {
                        this.$router.push('/admin/bidders/');
                    }, 1000);
                })
                .catch(error=>{
                    let {data:errorMessage} = error.response;
                    let err = null;
                    if(errorMessage.hasOwnProperty('url')) err = errorMessage.url;
                    this.$notify({
                        title: 'Warning',
                        message: err && err[0] || 'Something went wrong',
                        type: 'warning'
                    });
                })
            
            }
            else{
                axios.post(BASE_URL + 'bidder/v1/domains/'+`?add_to_core=${this.addToCoreDomain}`, domainObj)
                .then(response => {
                    this.$notify({
                        title: 'Success',
                        message: 'Successfully created a new domain',
                        type: 'success'
                    });
                    EventBus.$emit('update_logs', {});

                    setTimeout(() => {
                        this.$router.push('/admin/bidders/');
                    }, 1000);
                })
                .catch(error => {
                    let tempErr;
                    if(error.response){
                        let {data} = error.response;
                        tempErr = data.hasOwnProperty('url') && data.url;
                    }
                    this.$notify({
                        title: 'Error',
                        message: tempErr || 'Unable to create the domains',
                        type: 'error'
                    });                
                    console.error(error);
                })
            }

        },
        handleWebGoogle(){
            this.bing_web = 100 -this.web_traffic
        },
         handleWebBing(){
            this.web_traffic = 100 -this.bing_web
        },
        handleMobileGoogle(){
            this.bing_mobile = 100 -this.mobile_traffic
        },
         handleMobileBing(){
            this.mobile_traffic = 100 -this.bing_mobile
        },
    },
    computed: {
        formValid() {
            return this.name && this.pubId;
        }
    }
};
</script>



// WEBPACK FOOTER //
// Domain.vue?18edf6fe